import React, { useState } from 'react';
import { sankeyLinkHorizontal } from 'd3-sankey';

const makeDPath = sankeyLinkHorizontal<any, any>();

import styled from 'styled-components';
import { useDatasetStore } from '@src/shared/store';

const LinkWrapper = styled.g`
  path {
    transition: opacity 0.2s ease;

    &:hover {
      opacity: 0.8 !important;
    }
  }
`;

const SankeyLink = ({ link, onMouseEnter, onMouseLeave, isHighlighted }) => {
  const [isHovered, setIsHovered] = useState(false);

  const d = makeDPath(link);

  if (!d) return null;
  const strokeWidth = Math.max(3, link.width || 0);
  // const opacity = Math.min(0.8, Math.max(0.05, prop || 0.05));
  const opacity = 1;
  const color = `rgba(74, 144, 226, ${opacity > 1 ? 1 : opacity})`;

  return (
    <LinkWrapper
      as={'g'}
      onMouseEnter={() => {
        onMouseEnter?.(link);
        setIsHovered(true);
      }}
      onMouseLeave={() => {
        onMouseLeave?.(link);
        setIsHovered(false);
      }}
    >
      <path
        d={d}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        opacity={isHovered || isHighlighted ? 0.8 : 0.3}
      />
    </LinkWrapper>
  );
};

export default SankeyLink;
